<mat-calendar #calendar
              [minDate]='minDate'
              [maxDate]='maxDate'
              (selectedChange)="daySelected($event,calendar)"
              [dateClass]="dateClass">
</mat-calendar>
